import {
  GET_STEPS,
  GET_STEPS_SUCCESS,
  GET_STEPS_FAILURE,
  SET_CURRENT_STEP,
  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
  GET_PERSONAL_INFO,
  GET_PERSONAL_INFO_SUCCESS,
  GET_PERSONAL_INFO_FAILURE,
  SET_PERSONAL_INFO,
  SET_PERSONAL_INFO_SUCCESS,
  SET_PERSONAL_INFO_FAILURE,
  GET_PAYROLL_INFO,
  GET_PAYROLL_INFO_SUCCESS,
  GET_PAYROLL_INFO_FAILURE,
  SET_PAYROLL_INFO,
  SET_PAYROLL_INFO_SUCCESS,
  SET_PAYROLL_INFO_FAILURE,
  VALIDATE_EMPLOYEE,
  VALIDATE_EMPLOYEE_SUCCESS,
  VALIDATE_EMPLOYEE_FAILURE,
  GET_STEP_DATA,
  GET_STEP_DATA_SUCCESS,
  GET_STEP_DATA_FAILURE,
  SET_FIELDS,
  SAVE_RESPONSE,
  SAVE_RESPONSE_SUCCESS,
  SAVE_RESPONSE_FAILURE,
  DELETE_ANSWER,
  DELETE_ANSWER_SUCCESS,
  DELETE_ANSWER_FAILURE,
  UPDATE_STATUS,
  UPDATE_STATUS_SUCCESS,
  UPDATE_STATUS_FAILURE,
  GET_REQUIRED_DOCS,
  GET_REQUIRED_DOCS_SUCCESS,
  GET_REQUIRED_DOCS_FAILURE,
} from "./constants";

export const getSteps = (payload, callback) => ({
  type: GET_STEPS,
  payload,
  callback,
});

export const setCurrentStep = (payload) => ({
  type: SET_CURRENT_STEP,
  payload,
});

export const getStepsSuccess = (payload) => ({
  type: GET_STEPS_SUCCESS,
  payload,
});

export const getStepsFailure = (payload) => ({
  type: GET_STEPS_FAILURE,
  payload,
});

export const setPassword = (payload, callback) => ({
  type: SET_PASSWORD,
  payload,
  callback,
});
export const setPasswordSuccess = (payload) => ({
  type: SET_PASSWORD_SUCCESS,
  payload,
});
export const setPasswordFailure = (payload) => ({
  type: SET_PASSWORD_FAILURE,
  payload,
});

export const getPersonalInfo = (payload, callback) => ({
  type: GET_PERSONAL_INFO,
  payload,
  callback,
});

export const getPersonalInfoSuccess = (payload) => ({
  type: GET_PERSONAL_INFO_SUCCESS,
  payload,
});

export const getPersonalInfoFailure = (payload) => ({
  type: GET_PERSONAL_INFO_FAILURE,
  payload,
});

export const setPersonalInfo = (payload, callback) => ({
  type: SET_PERSONAL_INFO,
  payload,
  callback,
});

export const setPersonalInfoSuccess = (payload) => ({
  type: SET_PERSONAL_INFO_SUCCESS,
  payload,
});

export const setPersonalInfoFailure = (payload) => ({
  type: SET_PERSONAL_INFO_FAILURE,
  payload,
});

export const getPayrollInfo = (payload, callback) => ({
  type: GET_PAYROLL_INFO,
  payload,
  callback,
});

export const getPayrollInfoSuccess = (payload) => ({
  type: GET_PAYROLL_INFO_SUCCESS,
  payload,
});

export const getPayrollInfoFailure = (payload) => ({
  type: GET_PAYROLL_INFO_FAILURE,
  payload,
});

export const setPayrollInfo = (payload, callback) => ({
  type: SET_PAYROLL_INFO,
  payload,
  callback,
});

export const setPayrollInfoSuccess = (payload) => ({
  type: SET_PAYROLL_INFO_SUCCESS,
  payload,
});

export const setPayrollInfoFailure = (payload) => ({
  type: SET_PAYROLL_INFO_FAILURE,
  payload,
});

export const validateEmployee = (payload, callback) => ({
  type: VALIDATE_EMPLOYEE,
  payload,
  callback,
});

export const validateEmployeeSuccess = (payload) => ({
  type: VALIDATE_EMPLOYEE_SUCCESS,
  payload,
});

export const validateEmployeeFailure = (payload) => ({
  type: VALIDATE_EMPLOYEE_FAILURE,
  payload,
});

export const getStepData = (payload, callback) => ({
  type: GET_STEP_DATA,
  payload,
  callback,
});

export const getStepDataSuccess = (payload) => ({
  type: GET_STEP_DATA_SUCCESS,
  payload,
});

export const getStepDataFailure = (payload) => ({
  type: GET_STEP_DATA_FAILURE,
  payload,
});

export const setFields = (payload, callback) => ({
  type: SET_FIELDS,
  payload,
  callback,
});

export const saveResponse = (payload, callback) => ({
  type: SAVE_RESPONSE,
  payload,
  callback,
});
export const saveResponseSuccess = (payload) => ({
  type: SAVE_RESPONSE_SUCCESS,
  payload,
});
export const saveResponseFailure = (payload) => ({
  type: SAVE_RESPONSE_FAILURE,
  payload,
});

export const deleteAnswer = (payload, callback) => ({
  type: DELETE_ANSWER,
  payload,
  callback,
});

export const deleteAnswerSuccess = (payload) => ({
  type: DELETE_ANSWER_SUCCESS,
  payload,
});

export const deleteAnswerFailure = (payload) => ({
  type: DELETE_ANSWER_FAILURE,
  payload,
});

export const updateStatus = (payload, callback) => ({
  type: UPDATE_STATUS,
  payload,
  callback,
});
export const updateStatusSuccess = (payload) => ({
  type: UPDATE_STATUS_SUCCESS,
  payload,
});
export const updateStatusFailure = (payload) => ({
  type: UPDATE_STATUS_FAILURE,
  payload,
});

export const getRequiredDocs = (payload, callback) => ({
  type: GET_REQUIRED_DOCS,
  payload,
  callback,
});

export const getRequiredDocsSuccess = (payload) => ({
  type: GET_REQUIRED_DOCS_SUCCESS,
  payload,
});

export const getRequiredDocsFailure = (payload) => ({
  type: GET_REQUIRED_DOCS_FAILURE,
  payload,
});
